import { defineMessages } from 'react-intl'

const messages = defineMessages({
  espanol: {
    id: 'LanguageControllerResponsive.espanol',
    description: 'Español',
    defaultMessage: 'Español'
  },
  euskera: {
    id: 'LanguageControllerResponsive.euskera',
    description: 'Euskera',
    defaultMessage: 'Euskera'
  },
  english: {
    id: 'LanguageControllerResponsive.english',
    description: 'English',
    defaultMessage: 'English'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageControllerResponsive/messages.js